// extracted by mini-css-extract-plugin
export var configurationSection = "_sf-0";